module.exports = __webpack_public_path__ + "static/img/21.ea27cae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn2/21.jpg
// module id = FYDU
// module chunks = 0